import { redirect } from 'react-router-dom';
import auth from '@/shared/config/auth.config';

// Loader for protected routes
export async function authLoader() {
  try {
    const isAuthenticated = auth.isAuthenticated();

    if (!isAuthenticated) {
      return redirect('/login');
    }

    if (auth.isTokenExpired()) {
      try {
        await auth.refreshToken();
      } catch (error) {
        console.error('Token refresh failed:', error);
        auth.clearTokens();
        return redirect('/login');
      }
    }

    return {
      user: auth.getUserFromToken(),
    };
  } catch (error) {
    console.error('Auth loader error:', error);
    return redirect('/login');
  }
}

// Loader for guest routes (login, register, etc.)
export async function guestLoader() {
  try {
    const isAuthenticated = auth.isAuthenticated();

    if (isAuthenticated) {
      return redirect('/');
    }

    return null;
  } catch (error) {
    console.error('Guest loader error:', error);
    return null;
  }
}
